import { render, staticRenderFns } from "./CampusAdd.vue?vue&type=template&id=5c213a67&scoped=true&"
import script from "./CampusAdd.vue?vue&type=script&lang=ts&"
export * from "./CampusAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c213a67",
  null
  
)

export default component.exports